import styled, { css } from 'styled-components'
import { PopupProps } from '@elamajs/ui-kit'

export const Container = styled.div`
  position: relative;
`

export type StyledSelectProps = {
  isSelected: boolean
  isOpen: boolean
  disabled?: boolean
}

export const Label = styled.label<StyledSelectProps>`
  padding: 15px 20px;
  height: 50px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: ${({ theme }) => theme.palette.white};
  border: 1px solid ${({ theme }) => theme.palette.black[80]};
  border-radius: 5px;

  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-family: Navigo, Arial, Helvetica, sans-serif;

  &:hover {
    outline: 1px solid ${({ theme }) => theme.palette.black[80]};
  }

  & svg {
    color: ${({ theme }) => theme.palette.black[20]};
    transition: 200ms ease-in-out 0s;
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      & > svg {
        transform: rotate(180deg);
      }
    `}

  ${({ isSelected, disabled, theme }) =>
    disabled
      ? css`
          color: ${theme.palette.black[70]};
          background-color: #edeff3;
          cursor: initial;

          &:hover {
            outline: none;
          }

          & > svg {
            color: ${theme.palette.black[70]};
          }
        `
      : isSelected
      ? css`
          color: ${theme.palette.black[20]};
        `
      : css`
          color: ${theme.palette.black[70]};
        `}
`

export const Popup = styled.div<PopupProps>`
  padding: 0;
  border-radius: 5px;
  max-width: unset;
  min-width: auto;
`

export const SearchInput = styled.input`
  padding-left: 46px;
  border-radius: 5px;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.palette.black[90]};
  font-size: 14px;
  line-height: 20px;

  &::placeholder {
    color: ${({ theme }) => theme.palette.black[70]};
  }

  &:focus,
  &:hover {
    border: none;
    box-shadow: none;
    border-bottom: 1px solid ${({ theme }) => theme.palette.black[90]};
  }
`

export const SearchIcon = styled.svg`
  color: ${({ theme }) => theme.palette.black[70]};
  padding-left: 5px;
  width: 21px;
`

export const OptionList = styled.ul`
  padding: 5px;
  display: flex;
  flex-direction: column;
  max-height: 250px;
  overflow-y: auto;
`

export const Option = styled.li`
  padding: 10px 15px;
  height: 40px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background-color: #edeff3;
  }
`
